module.exports = __webpack_public_path__ + "img/1spade-07.f2e648b4.svg";